




import { computed, defineComponent, PropType } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import { getMessagePreview } from "./views";

export default defineComponent({
  name: "MessagePreview",
  props: {
    message: { type: Object as PropType<Message>, required: true },
    isOpponentMessage: { type: Boolean, required: true },
  },
  setup(props) {
    const messagePreview = computed(() => getMessagePreview(props.message));
    return { messagePreview };
  },
});
